import ScrollAnimation from "react-animate-on-scroll";
import GgreenArrow from "../images/GgreenArrow.png";
import HomeSegment2IMG from "../images/homeSegment2IMG.jpg";
import { useContext } from "react";
import { SectionsContext } from "../store/section-context";

function Stats() {
  const { stats } = useContext(SectionsContext);
  return (
    <>
      <div className="homeSegment2 p-md-5 p-4 d-grid">
        <ScrollAnimation
          className="homeSegment2order2"
          animateIn="bounceInLeft"
          animationOut="fadeOut"
        >
          <div className=" homeSegment2container pb-4">
            <div>
              <div className="homeSegment2numbers">{stats.clientSatisfied}</div>
              <div className="homeSegment2subtext">Clients Satisfied</div>
            </div>
            <div>
              <div className="homeSegment2numbers">
                {stats.careHoursDelivered}
              </div>
              <div className="homeSegment2subtext">Care Hours Delivered</div>
            </div>
            <div>
              <div className="homeSegment2numbers">{stats.yearsExperience}</div>
              <div className="homeSegment2subtext">Years of Experience</div>
            </div>
          </div>
          <div className="homeSegment2textContainer">
            <div className="homeSegment2text pt-2 pt-md-5">{stats.cta}</div>
            <a
              href="/contact"
              className="homeSegment2contactcontainer pb-1 pt-4"
            >
              <div className="homeSegment2ccontact">Contact Us</div>
              <div>
                <img className="" src={GgreenArrow} alt="arrow" />
              </div>
            </a>
            <div className="homeSegment2textContainerline"></div>
          </div>
        </ScrollAnimation>
        <ScrollAnimation
          className="homeSegment2order1"
          animateIn="bounceInRight"
          animationOut="fadeOut"
        >
          <img
            className="HomeSegment2IMG"
            src={stats.uri || HomeSegment2IMG}
            alt="A Care Worker"
          />
        </ScrollAnimation>
      </div>
    </>
  );
}

export default Stats;
